const $body = $('body');


/**
 * Open the add to cart modal
 *
 * @param {string} productId product id
 * @param {string} addToCartUrl add to cart url
 */
function addToCartModal(productId, addToCartUrl) {
    $.spinner().start();
    $.ajax({
        url: addToCartUrl,
        method: 'GET',
        data: {
            pid: productId
        },
    }).done(response => {
        if (!response.success) {
            $body.append(response.html);
            const $toast = $('#productNotAddedToast');
            $toast.show();
            setTimeout(() => {
                $toast.remove();
            }, 3000);
        }

        if (response.success) {
            $body.append(response.html);
            const $modal = $('#petProfilerAddToCartModal');
            $modal.modal('show');
            $body.find('.js-pet-profiler-view-plan-btn').trigger('click');
        }

    }).always(() => {
        $.spinner().stop();
    });
}

/**
 * Construct the pet profiler URL
 *
 * @returns {string} the pet profiler URL
 */
function constructPetProfilerURL() {
    const baseUrl = window.location.origin + window.location.pathname;
    const params = new URLSearchParams();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cgid')) {
        params.append('cgid', urlParams.get('cgid'));
    }

    let paramIndex = 1;
    const activeLifeStage = $('.js-pet-profiler-life_stage .js-pet-profiler-refinement.active');

    if (activeLifeStage.length > 0) {
        const lifeStageValue = activeLifeStage.text().trim();
        params.append('prefn' + paramIndex, 'life_stage');
        params.append('prefv' + paramIndex, lifeStageValue);
        paramIndex++;
    }

    const activeSpecialty = $('.js-pet-profiler-specialty .js-pet-profiler-refinement.active');

    if (activeSpecialty.length > 0) {
        const specialtyValue = activeSpecialty.text().trim();
        params.append('prefn' + paramIndex, 'specialty');
        params.append('prefv' + paramIndex, specialtyValue);
        paramIndex++;
    }

    const activeAllergies = $('.js-pet-profiler-allergies .js-pet-profiler-refinement.active');
    activeAllergies.each(function () {
        const allergyValue = $(this).text().trim();
        params.append('prefn' + paramIndex, 'allergens');
        params.append('prefv' + paramIndex, allergyValue);
        paramIndex++;
    });

    const finalUrl = baseUrl + '?' + params.toString();
    return finalUrl;
}

/**
 * Update the mini cart
 *
 * @param {array} currentPids current products in the cart
 * @param {string} petProfilerMiniCartUrl the pet profiler mini cart url
 */
function petProfilerMiniCart(currentPids, petProfilerMiniCartUrl) {
    const $body = $('body');
    $.spinner().start();
    $.ajax({
        url: petProfilerMiniCartUrl,
        method: 'GET',
        data: {
            currentPids: JSON.stringify(currentPids)
        }
    }).done(function (data) {
        $('.js-pet-profiler-minicart__content').html(data);
        $('.js-pet-profiler-minicart').removeClass('d-none');
        $('.js-pet-profiler-search-results-content').removeClass('col-md-12').addClass('col-md-9').addClass('active-minicart');
        $body.find('.js-pet-profiler-dog-weight-input').trigger('focusout');
        $body.find('.js-pet-profiler-mobile-sticky').removeClass('d-none');
    }).always(function () {
        $.spinner().stop();
    });
}

module.exports = {
    addToCartModal: addToCartModal,
    constructPetProfilerURL: constructPetProfilerURL,
    petProfilerMiniCart: petProfilerMiniCart
};
